import { of as observableOf,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { IHome } from '../_interfaces';

@Injectable()
export class HomeService {
  constructor(private http: HttpService) {
  }

  fetchHomeData(): Observable<IHome> {
    return this.http.get<IHome>('/api/v2/pro/traversal/dashboard/home');
  }
}
